/**
 * Graphql mutation to cancel event
 * @module src/graphql/cancelInventoryTransfer
 */
import gql from 'graphql-tag';

/** cancel event */
const CANCEL_INVENTORY_TRANSFER = gql`
  mutation cancelInventoryTransfer(
    $externalId: String!
    $cancelReason: String
    $expectedCaseVersion: String
  ) {
    cancelInventoryTransfer(
      externalId: $externalId
      cancelReason: $cancelReason
      expectedCaseVersion: $expectedCaseVersion
    ) {
      message
    }
  }
`;

export default CANCEL_INVENTORY_TRANSFER;
